import { SiteSimpleImage, getImagesSrc } from "../siteSimpleImage"
import { isWcmEditor } from "../../../../config/serverConfig"
require('./site_imageSlider.less')
require('./m_imageSlider.less')
require('./app_imageSlider.less')


interface imageSliderProps {
    sliderTitle?: string
    isSliderTitle: boolean
    imageUrl1: string
    title1: string
    credit1: string
    imageUrl2: string
    title2: string
    credit2: string
    imagesDomain?:string
    sitename?:string
}
interface imageSliderState {
    sliderValue: number
    innerDivWidth: number
}

export class ImageSlider extends React.Component<imageSliderProps, imageSliderState> {
    public imageSlider: HTMLDivElement;
    constructor(props) {
        super(props)
        this.state = {
            sliderValue: 50,
            innerDivWidth: null
        }
    }
    public componentDidMount() {
        const sideBarHeight = this.imageSlider.clientWidth;
        this.setState({
            innerDivWidth: sideBarHeight
        })
    }

    public static siteScriptName = "ImageSlider"


    private updateSliderValue = (e: HTMLInputElement) => {
        const value = parseInt(e.value)
        this.setState({ sliderValue: value })

    }


    public render() {
        const { sliderTitle, isSliderTitle, imageUrl1, imageUrl2, credit1, credit2, title1, title2 , imagesDomain, sitename} = this.props;
        const { sliderValue, innerDivWidth } = this.state
  let firstImageCreditText = "תמונה ימין - " + credit1;
                    let secondImageCreditText = "תמונה שמאל - " + credit2;
                    if (sitename === "ynetnews" || sitename==="ctech") {
                        firstImageCreditText = credit1 ? "Photo on the left - " + credit1 : "";
                        secondImageCreditText = credit2 ? "Photo on the right - " + credit2 : "";
                    }
                    if (sitename === "vesty") {
                        firstImageCreditText = credit1 ? "Фото слева - " + credit1 : "";
                        secondImageCreditText = credit2 ? "Фото справа - " + credit2 : "";
                    }
        return (
             <div className="ImageSliderContainer">
            <div className="ImageSlider" ref={ref => this.imageSlider = ref} >
                <div>
                    <div className="bottomPicture" >
                        <SiteSimpleImage src={getImagesSrc(imagesDomain, imageUrl1)} title={credit1} alt={credit1} />
                        <div className={`bottomImg imgTitle ${sliderValue < 60 ? "visible" : "hidden"}`} >{title1}</div>

                    </div>
                    <div className="topPicture" style={{ width: `${this.state.sliderValue}%` }}>
                        <div id="innerSliderDiv" style={{ width: `${innerDivWidth}px` }}>
                            <SiteSimpleImage src={getImagesSrc(imagesDomain, imageUrl2)} title={credit2} alt={credit2} />
                            <div className={`topImg imgTitle ${sliderValue > 40 ? "visible" : "hidden"}`}>{title2}</div>
                        </div>

                    </div>
                    {isSliderTitle && <div className="imagesSliderTitle" >{sliderTitle}</div>}    
                   <input type="range" disabled={isWcmEditor()} min="0" max="100" value={`${this.state.sliderValue}`} id="slider"
                      onChange={(e) => this.updateSliderValue(e.target as HTMLInputElement)}  ></input>   
                </div>
         
            </div>
               <div className="ImageDetails" style={{marginTop:"10px"}}>{firstImageCreditText} | {secondImageCreditText}</div> 
            </div>
        )
    }
}
